export const fields = {
  computed: {
    fields() {
      return [
        {
          key: 'transaction_date',
          name: 'transaction_date',
          label: this.$t('invoice.fields.invoiceDate'),
          valueType: 'YYYY-MM-DD',
          type: 'date-picker',
          validation: 'required',
          format: 'DD MMMM YYYY',
        },
        {
          key: 'total_days',
          name: 'total_days',
          label: this.$t('invoice.fields.totalOfDays'),
          placeholder: this.$t('invoice.placeholder.totalOfDays'),
          _type: 'number',
          validation: 'bail|required|number|min:0,value|max:1000000,value|integer',
          'validation-messages': {
            min: this.$t('global.validation.minPositiveOnly')
          },
        },  
        {
          key: 'due_date',
          name: 'due_date',
          label: this.$t('invoice.fields.dueDate'),
          placeholder: this.$t('invoice.placeholder.dueDate'),
          valueType: 'YYYY-MM-DD',
          type: 'date-picker',
          validation: 'required',
          format: 'DD MMMM YYYY',
          disabled: true
        }
      ]
    }
  }
}